import { InterviewService } from "./interview.service";

export const Services = {
	interviewService: InterviewService,
};
